// extracted by mini-css-extract-plugin
module.exports = {"liked":"PostCommentReplyLikeText_liked__Gtq0j","like":"PostCommentReplyLikeText_like__3SkC5","reply":"PostCommentReplyLikeText_reply__3JfNj"};